import { Box, Typography } from "@mui/material";
import coverImage from "../../../../media/images/headCover.svg";

import FaqCard from "./FaqCard";
export default function GuideMain() {
  const faqs = [
    {
      q: "ثبت نام اولیه به چه صورت است؟",
      a: "صاحبین کلا (حقیقی و حقوقی)، رانندگان، شرکت های حمل و نقل در ابتدا شناسه ملی/کدملی  و شماره تلفن همراه خود را وارد کرده و کد فعال سازی پیامک می­ شود و در صورت صحیح بودن و تطابق شماره تلفن با صاحب کدملی خودکار وارد اپلیکیشن کارن ترابر نت می شوید.",
    },
    {
      q: "روش ثبت اطلاعات در پروفایل؟",
      a: "پس از ورود به اپلیکیشن کاربر در حالت کاربر احراز نشده قرار میگیرد و در بخش منوی نرم افزار قسمت ویرایش اطلاعات اطلاعات خود را تکمیل و مدارک مورد نیاز را بارگزاری نمایید و پس از بررسی در پروفایل علامت کاربر احراز شده دریافت می شود.",
    },
    {
      q: "چه مدارکی برای تکمیل ثبت نام نیاز است؟",
      a: `صاحبین کالا: <br/> اگر ثبت نام حقیقی باشد تصویر رو و پشت کارت ملی <br/> اگر ثبت نام حقوقی باشد تصویر روزنامه رسمی، تصویر رو و پشت کارت ملی مدیرعامل <br/> <br/>  رانندگان: <br/>
تصویر رو و پشت کارت ملی، تصویر رو و پشت گواهینامه، تصویر رو و پشت کارت هوشمند راننده <br/> <br/> شرکت های حمل و نقل: <br/> تصویر روزنامه رسمی، تصویر رو و پشت کارت ملی مدیرعامل، تصویر پروانه فعالیت سازمان راهداری و حمل و نقل جاده ای`,
    },
    {
      q: "روش ثبت بار در اپلیکیشن؟",
      a: `با نصب اپلیکیشن یا از طریق سامانه آنلاین در صورتی که احراز هویت انجام شده باشد در قسمت ثبت سفارش اطلاعات فرستنده، گیرنده، آدرس مبدا و مقصد و نوع بار را مشخص کرده و پس از نهایی کردن سفارش یک شرکت حمل و نقل اتوماتیک نسبت به مبدا تخصیص داده می شود.`,
    },
    {
      q: "دریافت بار و مجوز به صورت است؟",
      a: `بارهای اعلام شده در اپلیکیشن رانندگان قابل مشاهده بوده و هر راننده نسبت به نوع بارگیر ناوگان بار مورد نظر را انتخاب و یک مجوز جهت بارگیری و دریافت بارنامه صادر می شود.`,
    },
    {
      q: "چگونه سفارش بار را رهگیری کنیم؟",
      a: `از مرحله ثبت سفارش تا مرحله تحویل و تخلیه بار برای هر کدام از سفارش ها قابل رهگیری است و با گزارشی که برای صاحبین کالا و شرکت های حمل و نقل در نظر گرفته شده است مرحله به مرحله روند کار را در اپلیکیشن یا سامانه آنلاین مشاهده می نمایید.`,
    },
  ];

  // const guids = [
  //   {
  //     path: "signup-guides",
  //     title: "راهنما <br/> ثبت‌نام",
  //     icon: <UserRegIcon color={theme.palette.secondary.dark} />,
  //   },
  //   {
  //     path: "login",
  //     title: "راهنما <br/> ورود",
  //     icon: <UserLoginIcon color={theme.palette.secondary.dark} />,
  //   },
  //   {
  //     path: "condignment-owner",
  //     title: "راهنمای <br/> صاحبان کالا",
  //     icon: <UserProfileIcon color={theme.palette.secondary.dark} />,
  //   },
  //   {
  //     path: "drivers",
  //     title: "راهنمای <br/> رانندگان",
  //     icon: <BigCarIcon color={theme.palette.secondary.dark} />,
  //   },
  // ];

  return (
    <Box
      sx={{
        flex: "1",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          borderRadius: "20px",
          justifyContent: "end",
          paddingX: "16px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "60px",
            fontSize: "22px",
            fontWeight: "900",
            color: "#fff",
          }}
        >
          {/* راهنمای بازارگاه{" "} */}
          سوالات متداول
        </Typography>
        <Typography
          sx={{
            marginBottom: "16px",
            color: "#fff",
          }}
        >
          {/* راهنمای جامع خدمات و سوالات متداول کاربران{" "} */}
          بازارگاه آنلاین کارن ترابر نت
        </Typography>
      </Box>

      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          paddingX: "8px",
          borderRadius: "8px",
        }}
      >
        <TextField
          placeholder="سوال یا موضوع را جست‌وجو کنید "
          size="small"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-input": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
            },
            border: "none",
          }}
        />
        <SearchIcon color={theme.palette.primary.main} />
      </Box> */}
      {/* <Typography
        sx={{
          textAlign: "center",
          fontSize: "14px",
        }}
      >
        می‌توانید از دسته‌بندی‌های زیر انتخاب کنید:
      </Typography> */}

      {/* <Box
        sx={{
          display: "flex",
          // alignItems: "center",
          gap: "16px",
        }}
      >
        {guids.map((item) => (
          <Link
            to={item.path}
            style={{
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: theme.palette.secondary.dark,
              boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              padding: "8px 8px 8px 8px",

              borderRadius: "16px",
              justifyContent: "center",
              alignItems: "center",

              gap: "10px",

              backgroundColor: theme.palette.background.default,
            }}
          >
            {item.icon}
            <Typography
              sx={{
                textAlign: "center",
                color: "secondary.dark",
                fontSize: "14px",
              }}
            >
              <div
                style={{
                  whiteSpace: "nowrap",
                }}
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
            </Typography>
          </Link>
        ))}
      </Box> */}

      <Box
        sx={{
          marginTop: "16px",
        }}
      >
        {/* <Typography
          sx={{
            color: "primary.main",
            fontSize: "16px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          سوالات متداول:
        </Typography> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "8px",
          }}
        >
          {faqs.map((item) => (
            <FaqCard {...item} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
